/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TaskSuggestion } from './TaskSuggestion.js';
import {
    TaskSuggestionFromJSON,
    TaskSuggestionFromJSONTyped,
    TaskSuggestionToJSON,
} from './TaskSuggestion.js';

/**
 * 
 * @export
 * @interface TaskSuggestionsListResponse
 */
export interface TaskSuggestionsListResponse {
    /**
     * 
     * @type {Array<TaskSuggestion>}
     * @memberof TaskSuggestionsListResponse
     */
    data?: Array<TaskSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof TaskSuggestionsListResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof TaskSuggestionsListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof TaskSuggestionsListResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof TaskSuggestionsListResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the TaskSuggestionsListResponse interface.
 */
export function instanceOfTaskSuggestionsListResponse(value: object): boolean {
    return true;
}

export function TaskSuggestionsListResponseFromJSON(json: any): TaskSuggestionsListResponse {
    return TaskSuggestionsListResponseFromJSONTyped(json, false);
}

export function TaskSuggestionsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskSuggestionsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(TaskSuggestionFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function TaskSuggestionsListResponseToJSON(value?: TaskSuggestionsListResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(TaskSuggestionToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

